import { useState, useEffect } from 'react';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    google: any;
  }
}

export default function useGooglePlaces(resultsElementRef: any) {
  const [results, setResults] = useState<any>(null);
  let service: any;

  const initService = () => {
    if (
      !service &&
      window.google &&
      window.google.maps &&
      window.google.maps.places &&
      resultsElementRef &&
      resultsElementRef.current
    ) {
      service = new window.google.maps.places.PlacesService(
        resultsElementRef.current
      );
    }
  };

  const findPlace = (query: string, locationBias?: any) => {
    initService();

    if (service && query) {
      const request = {
        query,
        fields: ['name', 'geometry'],
        locationBias
      };

      service.findPlaceFromQuery(request, (queryResults: any, status: any) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          queryResults &&
          queryResults.length
        ) {
          const place: any = queryResults[0];

          if (!place.geometry || !place.geometry.location) return;

          setResults({
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          });
        }
      });
    }
  };

  useEffect(() => {
    initService();
  }, []);

  return { results, findPlace };
}
